var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "shop-wishlist" },
    [
      _c("shop-headline", {
        attrs: { headline: _vm.$t("wishlist.wishlist"), icon: "star" },
      }),
      _vm._v(" "),
      _vm.isEmpty
        ? [
            _c("p", {
              domProps: { innerHTML: _vm._s(_vm.$t("wishlist.isEmpty")) },
            }),
          ]
        : [
            !_vm.authenticated
              ? _c(
                  "shop-section",
                  [
                    _c("template", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("wishlist.login.headline")),
                      },
                      slot: "headline",
                    }),
                    _vm._v(" "),
                    _c(
                      "shop-login",
                      {
                        attrs: { slot: "body", buttons: _vm.buttons },
                        slot: "body",
                      },
                      [
                        [
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("wishlist.login.body")),
                            },
                          }),
                        ],
                      ],
                      2
                    ),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.wishlistData.items, function (section, sectionIndex) {
              return [
                _c(
                  "div",
                  { attrs: { id: section.category } },
                  [
                    section.items.length
                      ? _c(
                          "global-accordion",
                          {
                            attrs: {
                              "accordion-type": "2",
                              open: _vm.accordionStates[sectionIndex],
                              inactive: false,
                            },
                            on: {
                              toggleAccordion: function ($event) {
                                return _vm.toggleAccordion(sectionIndex)
                              },
                            },
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(section.sectionTitle) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "template",
                              { slot: "body" },
                              [
                                section.category === "decorset" ||
                                section.category === "roomset"
                                  ? [
                                      _vm.wishlistResponsiveImages.teaserImages[
                                        section.category
                                      ]
                                        ? _c("global-responsive-image", {
                                            attrs: {
                                              "responsive-image":
                                                _vm.wishlistResponsiveImages
                                                  .teaserImages[
                                                  section.category
                                                ],
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(
                                        section.items,
                                        function (decorset, decorsetIndex) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "row global-edit",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col-10" },
                                                  [
                                                    _vm.edit.sectionIndex ===
                                                      sectionIndex &&
                                                    _vm.edit.decorsetIndex ===
                                                      decorsetIndex
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "global-edit--edit",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "global-edit--form form__input--with-button",
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.edit
                                                                          .inputvalue,
                                                                      expression:
                                                                        "edit.inputvalue",
                                                                    },
                                                                  ],
                                                                  staticClass:
                                                                    "form__input form__input--text",
                                                                  attrs: {
                                                                    type: "text",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm.edit
                                                                        .inputvalue,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        )
                                                                          return
                                                                        _vm.$set(
                                                                          _vm.edit,
                                                                          "inputvalue",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c("button", {
                                                                  staticClass:
                                                                    "button button--secondary button--icon icon--before icon--close",
                                                                  attrs: {
                                                                    "aria-label":
                                                                      "discard",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.decorsetCloseEdit,
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "button button--ghost icon--before icon--save",
                                                                on: {
                                                                  click:
                                                                    _vm.decorsetSaveEdit,
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "wishlist.save"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "global-edit--editable",
                                                          },
                                                          [
                                                            _c(
                                                              "h3",
                                                              {
                                                                staticClass:
                                                                  "headline headline--center-v headline--editable",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                    " +
                                                                    _vm._s(
                                                                      decorset.name
                                                                    ) +
                                                                    "\n                                                    "
                                                                ),
                                                                _c("button", {
                                                                  staticClass:
                                                                    "button button--secondary button--icon icon--before icon--edit icon--small",
                                                                  attrs: {
                                                                    "aria-label":
                                                                      "edit",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.decorsetOpenEdit(
                                                                          decorset,
                                                                          sectionIndex,
                                                                          decorsetIndex
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "col-2" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "button-wrapper right",
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "button button--ghost icon--before icon--trash",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.remove(
                                                                  decorset,
                                                                  sectionIndex,
                                                                  decorsetIndex
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "wishlist.remove"
                                                                    )
                                                                  ) +
                                                                  "\n                                                    "
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "row" },
                                              [
                                                _vm._l(
                                                  decorset.decors,
                                                  function (decor) {
                                                    return [
                                                      _c("shop-tile", {
                                                        staticClass:
                                                          "col-12 col-md-6",
                                                        attrs: { tile: decor },
                                                      }),
                                                    ]
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _vm.showRoomdesignerButton
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "button-wrapper fill--xs full-width--xs spacer--top-small right",
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "button button--secondary icon--before icon--roomdesigner",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openRoomdesigner(
                                                              sectionIndex,
                                                              decorsetIndex
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "wishlist.toRoomDesigner"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        }
                                      ),
                                    ]
                                  : [
                                      section.howToOrder
                                        ? _c("div", [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(section.howToOrder)
                                              ),
                                            ]),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "row" },
                                        [
                                          _vm._l(
                                            section.items,
                                            function (item, itemIndex) {
                                              return [
                                                _c(
                                                  "shop-tile",
                                                  {
                                                    staticClass:
                                                      "col-12 col-md-6",
                                                    attrs: { tile: item },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "button-area" },
                                                      [
                                                        item.ordernumber
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "button-wrapper spacer--top",
                                                              },
                                                              [
                                                                _c("button", {
                                                                  staticClass:
                                                                    "button button--secondary icon--before icon--shop cart-available",
                                                                  attrs: {
                                                                    "data-pid":
                                                                      item.order_pid,
                                                                    "data-title":
                                                                      item.title,
                                                                    "data-titlesuffix":
                                                                      item.titlesuffix,
                                                                    "data-subtitle":
                                                                      item.subtitle,
                                                                    "data-subsubtitle":
                                                                      item.subsubtitle,
                                                                  },
                                                                  domProps: {
                                                                    innerHTML:
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "wishlist.toCart"
                                                                        )
                                                                      ),
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "template",
                                                      { slot: "remove-button" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "button-wrapper spacer--top-small",
                                                          },
                                                          [
                                                            _c("button", {
                                                              staticClass:
                                                                "button button--ghost icon--before icon--trash",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "wishlist.remove"
                                                                    )
                                                                  ),
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.remove(
                                                                      item,
                                                                      sectionIndex,
                                                                      itemIndex
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      section.category === "decor" &&
                                      _vm.showRoomdesignerButton
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "button-wrapper fill--xs full-width--xs spacer--top-small right",
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "button button--secondary icon--before icon--roomdesigner",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openRoomdesigner(
                                                          sectionIndex
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "wishlist.toRoomDesigner"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                              ],
                              2
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            }),
          ],
      _vm._v(" "),
      _vm.showRoomdesignerButton
        ? _c("global-roomdesigner-selection", {
            attrs: { "initial-data": _vm.roomdesignerModalData },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }